import React from 'react';
import { Popup } from 'cd-eft/components/common/Popup';

interface IDeleteElementProps {
  trigger: boolean;
  setTrigger: any;
  element: string;
  name: string;
  action: any;
}

export const DeleteElement = (props: IDeleteElementProps) => {
  const { element, name, action, trigger, setTrigger } = props;
  const capitalizedName = `${element[0].toUpperCase()}${props.element.slice(1)}`;

  return (
    <Popup
      trigger={trigger}
      setTrigger={setTrigger}
      title={`Delete ${capitalizedName}?`}
      handleCancel={setTrigger}
      cancelText="Close"
      handleOK={action}
      okText="Okay"
    >
        Are you sure you want to delete the {element} <span className="text-underline">{name}</span>?
    </Popup>
  );
};
